module.exports = __webpack_public_path__ + "img/weui_code.9a1ea382.png";